/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-console */

import { useGlobal } from 'providers/hooks'
import React, { useState } from 'react'
import { ProductType } from 'type/menu'
import { VideoModal } from '../video'

export const ProductV2 = ({
  product,
  subCategory,
  idx,
  showCategory,
  hidden_products,
  filteredTags,
  isPerfectMatchFilter,
  removeTopBorder,
  isArabic
}: {
  product: ProductType['product']
  subCategory?: ProductType['sub_category']
  idx?: number
  showCategory?: boolean
  hidden_products?: number[]
  filteredTags?: string[]
  isPerfectMatchFilter?: boolean
  removeTopBorder?: boolean
  isArabic?: boolean
}) => {
  const global = useGlobal()
  const { showAllergens, showCalories } = global
  const [isOpen, setIsOpen] = useState(false)
  const isBestOfProduct = product?.attributes?.best_of_product
  const pairingProduct = product?.attributes?.pairing_product
  const marketingTags = product?.attributes?.tags.map((tag) => tag.marketing_title)
  const tags = product?.attributes?.tags.map((tag) => tag.title)
  const allTags = [...marketingTags, ...tags]
  const matchedTagsFilter = filteredTags?.filter((tag) => allTags.includes(tag))
  const showCategoryTitle = showCategory && subCategory?.attributes?.title

  const thereIsSubCategory = subCategory?.attributes?.title

  const ctaUrl = product?.attributes?.cta_url
  const ctaText = product?.attributes?.cta_text || 'click'

  const closeModal = () => {
    setIsOpen(false)
  }

  const openModal = () => {
    setIsOpen(true)
  }

  const isVideo = product?.attributes?.is_video_product
  const image = product?.attributes?.image
  const type = product?.attributes?.type?.replace('-star', '*')

  const hideProduct = hidden_products?.includes(+product.attributes.product_id)
  const isPairingProductHidden = pairingProduct && hidden_products?.includes(pairingProduct.id)

  if (isVideo) {
    return (
      <>
        <VideoModal isOpen={isOpen} closeModal={closeModal} content={product?.attributes?.video} />
        <div className="w-full">
          <img src={product?.attributes?.gif} alt="gif" className="mx-auto cursor-pointer w-80" onClick={openModal} />
        </div>
      </>
    )
  }

  const subcategoryAndHiddenAndNoDescription =
    thereIsSubCategory && !subCategory?.attributes?.description && hideProduct

  const subcategoryAndNoHiddenAndDescription = thereIsSubCategory && subCategory?.attributes?.description && hideProduct
  const productDescription = product.attributes?.description?.trim()

  if (isBestOfProduct && image) {
    return (
      <div className="grid grid-cols-2 border border-primary">
        <div className={`${isArabic ? 'col-[2/3]' : 'border-r'} min-h-[220px] border-primary relative`}>
          {image && <img className="absolute top-0 left-0 w-full h-full object-contain" src={image} alt="product" />}
        </div>
        <div
          className={`flex flex-col justify-center ${isArabic ? 'row-start-1 col-[1/2] text-right border-r border-primary' : 'text-left'}`}
        >
          <div className="px-4 py-6 text-center my-auto">
            {product.attributes.pre_title && (
              <p className="font-mammaBody text-[12px] mb-1 underline">{product.attributes?.pre_title}</p>
            )}
            {product.attributes?.title && (
              <p translate="no" className="uppercase font-mammaTitle text-[12px] tracking-[0.02em] leading-[120%]">
                {product.attributes?.title}
              </p>
            )}
            {productDescription && (
              <p className="text-[14px] leading-[120%] mt-1 font-mammaBody whitespace-pre-wrap">{productDescription}</p>
            )}
            {product?.attributes.price && (
              <p className="uppercase font-mammaTitle text-[12px] tracking-[0.02em] leading-[120%] mt-6">
                {product.attributes.price}
              </p>
            )}
          </div>
          {ctaUrl && (
            <a
              href={ctaUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="h-[50px] w-full bg-primary text-white flex items-center px-4 justify-center font-mammaTitle text-[12px] tracking-[0.02em] uppercase"
            >
              {ctaText}
            </a>
          )}
        </div>
      </div>
    )
  }

  return (
    <div
      className={`relative ${isBestOfProduct ? 'p-4 border border-primary' : ''} ${image ? `grid gap-3 ${isArabic ? 'grid-cols-[1fr_auto]' : 'grid-cols-[auto_1fr]'}` : ''}`}
    >
      {isBestOfProduct && (
        <div className={`absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white`}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M15.03 8.94462C14.9197 8.9638 14.9916 9.01654 15.03 9.06449C15.2074 9.28986 15.4807 9.48166 15.6533 9.70703C16.3007 10.5653 16.5452 11.9895 16.8377 13.0108C16.8904 13.193 17.0151 13.3608 17.0631 13.5622C17.1302 13.8355 16.9911 15.9358 16.9192 16.2762C16.7178 17.1968 16.1185 18.036 15.8499 18.8943C15.7109 19.3354 15.9746 19.719 15.7972 20.165C15.5095 20.9034 14.795 21.1575 14.1045 20.7595C13.4476 20.3807 13.2798 20.0307 12.4359 19.9252C11.6543 19.8245 10.4124 19.8485 9.7219 19.4985C9.55886 19.4169 9.45337 19.2875 9.30952 19.2012C7.28602 17.988 5.37281 16.2858 4.36586 14.128C4.02062 13.3848 4.16926 13.006 4.14529 12.2963C4.1309 11.884 3.95828 11.3565 3.95349 10.901C3.9439 10.2441 4.12611 8.88228 4.42819 8.32127C4.69192 7.83217 5.18101 7.40062 5.32966 6.84919C5.40158 6.58067 5.22417 5.36753 5.18581 4.98873C5.12827 4.41332 4.84056 3.62694 5.37761 3.17141C5.48789 3.08031 6.06329 2.97961 6.21194 3.00359C6.6387 3.08031 7.03668 3.49747 7.48262 3.65571C8.44162 3.99136 9.51091 3.32006 10.4364 3.26252C11.2419 3.21457 12.4071 3.28649 13.1695 3.55502C14.2963 3.94821 16.0993 4.78734 17.0535 5.47782C17.9118 6.09638 19.0194 7.00263 19.8106 7.7123C20.0264 7.90889 20.9662 8.83433 21.0286 9.03572C21.1245 9.35219 20.8511 9.58236 20.549 9.60154C19.9641 9.6351 18.866 9.32342 18.2187 9.24191C17.4035 9.14121 16.5884 9.1508 15.778 9.07888C15.6485 9.06929 15.0683 8.94462 15.03 8.95421V8.94462ZM14.4929 5.5929L17.6145 6.73891C17.6241 6.63342 17.557 6.60944 17.4946 6.54711C17.0918 6.17789 16.6459 5.91896 16.1904 5.64564C15.965 5.51138 15.7684 5.25245 15.4663 5.29081L14.4977 5.5929H14.4929ZM14.819 4.87365C14.8094 4.8209 13.9895 4.46127 13.8648 4.46127C13.5387 4.45168 12.9154 4.90721 12.5701 4.95037C12.4886 4.95996 12.3687 4.93598 12.34 4.84967C12.2728 4.63389 13.0736 4.37496 13.1695 4.18796C13.1695 4.14001 12.8243 4.0489 12.7619 4.0489C12.479 4.04411 11.3618 4.77775 10.9542 4.92639C10.7384 5.00311 10.6138 5.0175 10.3836 4.98393C10.3261 4.54758 11.9132 4.02972 11.9036 3.86669L11.1268 3.80915L10.422 3.90505L8.57109 4.84967C9.08416 4.96475 9.60681 5.07983 10.1247 5.14696C10.9638 5.25245 11.8029 5.19012 12.6325 5.27643C13.1935 5.33397 13.7497 5.4922 14.3011 5.54974C14.1189 5.15176 14.5792 5.08463 14.819 4.89283V4.87365ZM19.6188 8.7672C18.9379 8.23975 18.2666 7.64996 17.4802 7.28554C17.2309 7.17046 16.8904 7.09374 16.6267 6.99304C16.4493 6.92591 16.2431 6.79165 16.0849 6.72932C16.0226 6.70534 15.9698 6.72452 15.9362 6.78686C16.55 7.35747 17.1206 7.99041 17.7679 8.52745C17.8447 8.57061 19.3455 8.81515 19.5085 8.81995C19.5613 8.81995 19.5757 8.87269 19.6236 8.772L19.6188 8.7672ZM16.8761 8.37881C16.387 7.94246 15.8979 7.40062 15.6102 6.80604C15.567 6.71493 15.5718 6.57108 15.5095 6.51834C15.356 6.37928 14.2676 6.04843 14.0134 6.00527C13.9511 5.99568 13.8888 5.95252 13.8456 6.02924C14.2484 6.43203 14.6368 6.9403 15.0588 7.31911C15.3608 7.58763 15.7253 7.83217 16.0417 8.0911C16.2335 8.24934 16.2144 8.36922 16.526 8.43635C16.5644 8.44594 16.8952 8.46512 16.8761 8.3836V8.37881ZM15.2649 8.33565V8.14864C14.469 7.63558 14.0278 6.71493 13.3901 6.08679C13.0592 5.76072 12.877 5.79908 12.4455 5.77031C12.0139 5.74154 11.5776 5.77031 11.146 5.74154C11.1316 5.82785 11.194 5.85183 11.2323 5.89978C11.731 6.54711 12.3496 7.11292 12.9441 7.67394C13.0065 7.73148 13.0161 7.85135 13.0736 7.88492C13.1168 7.90889 13.4956 7.95205 13.5723 7.92328L12.3064 6.35051C12.0858 5.77511 12.6756 6.28338 12.8674 6.456C13.4189 6.95948 13.9895 7.73148 14.6032 8.12946C14.8142 8.26372 15.054 8.18701 15.2601 8.33565H15.2649ZM12.4023 7.78902C11.7118 7.15608 11.1652 6.40326 10.537 5.71277L8.24023 5.33876C8.18269 5.41548 9.02182 6.47039 8.95949 6.78686C8.91633 7.00743 8.60945 6.70055 8.53752 6.63342C8.26421 6.37449 7.87102 5.75593 7.77032 5.3963C7.74635 5.31958 7.79909 5.21889 7.77032 5.18532C7.70799 5.10381 7.2141 4.86406 7.16615 4.92639C7.66483 5.7847 8.10597 6.60465 8.96908 7.16087C9.22321 7.3239 9.59722 7.45816 9.87534 7.59242L10.2589 7.66435C9.97603 7.15608 9.58763 6.69575 9.33829 6.1683C9.26157 6.01007 9.13211 5.80388 9.28075 5.64564C9.48694 5.69839 9.56366 5.83265 9.67874 5.99088C10.1199 6.56629 10.4651 7.2328 10.8823 7.82258C11.0357 7.93287 12.0523 7.91848 12.2585 7.86574C12.316 7.85135 12.3687 7.87533 12.4023 7.79861V7.78902ZM8.60945 4.31742L7.80868 4.30304C7.46344 4.27906 7.14217 4.03452 6.80652 4.0537C6.93119 4.21673 8.11077 4.76816 8.21626 4.72979C8.26421 4.71061 8.50875 4.37496 8.60945 4.31742ZM9.7219 18.7121C9.7219 18.7121 11.0549 19.1101 11.6111 19.2395C12.4071 19.4265 12.8962 19.2683 13.6874 19.7718C14.071 20.0163 14.6847 20.6972 15.1403 20.2081C15.5047 19.8149 15.3081 19.7622 15.2841 19.369C15.241 18.6306 15.8883 17.7195 16.1712 17.0098C16.55 16.0604 16.4829 15.6481 16.5308 14.6795C16.5452 14.4061 16.6555 14.0513 16.6267 13.7828C16.6027 13.543 16.4253 13.2314 16.3582 12.9628C16.2096 12.3683 16.1328 11.6922 15.9938 11.0976C15.8403 10.4311 14.9149 9.39055 14.4066 8.93023C14.1669 8.71446 13.3134 8.59938 12.9633 8.56581C12.5462 8.52266 12.1626 8.5754 11.7694 8.55622C10.0767 8.47471 8.37449 7.79861 7.34356 6.39846L6.20714 4.4373L6.1544 5.99568C6.26469 7.20402 5.59818 7.75545 5.08032 8.68569C4.78302 9.21793 4.66315 10.8578 4.68712 11.4956C4.69671 11.7785 4.78782 12.0902 4.78782 12.3683C4.78782 12.9964 4.70151 13.1642 4.93646 13.8164C5.0995 14.2719 5.75162 15.3891 6.16878 15.6001C6.28386 15.6576 6.86886 16.0988 6.98394 16.233C7.46344 16.7989 8.03405 17.475 8.63343 17.9161C8.87797 18.0983 9.64517 18.6977 9.73628 18.7121H9.7219Z"
              fill="currentColor"
            />
            <path
              d="M9.72656 15.9216C9.87521 15.677 10.0814 15.5715 10.3355 15.7346C10.8678 16.0798 10.3739 16.6792 10.1581 16.5641C10.1245 16.5449 9.92316 15.9504 9.72656 15.9216Z"
              fill="currentColor"
            />
            <path
              d="M12.3493 17.6862C12.6082 17.8348 12.3109 18.3671 12.0184 18.089C11.8362 17.9115 12.0856 17.5327 12.3493 17.6862Z"
              fill="currentColor"
            />
            <path
              d="M14.6273 16.564C14.7376 16.9572 14.0088 16.938 14.1766 16.4969C14.2581 16.2811 14.5746 16.3674 14.6273 16.564Z"
              fill="currentColor"
            />
          </svg>
        </div>
      )}
      {image && (
        <div className={`flex items-start ${isArabic ? 'col-[2/3]' : ''}`}>
          <img className="w-[60px] aspect-[60/80] h-auto object-contain object-top" src={image} alt="product" />
        </div>
      )}

      <div className={`${isArabic ? 'text-right col-[1/2] row-start-1' : 'text-left'}`}>
        {product.attributes.pre_title && (
          <p className="font-mammaBody text-[12px] mb-1 underline">{product.attributes?.pre_title}</p>
        )}
        <div className={`min-h-[18px] grid gap-6 ${isArabic ? 'grid-cols-[auto_1fr]' : 'grid-cols-[1fr_auto]'}`}>
          {!isArabic && (
            <p translate="no" className="uppercase font-mammaTitle text-[12px] tracking-[0.02em] leading-[120%]">
              {isArabic && (
                <React.Fragment>
                  {showCalories && product?.attributes?.kcal && (
                    <span className="uppercase text-[12px] ml-2 tracking-[0.01em] leading-none font-mammaBody">
                      {product?.attributes?.kcal} kcal
                    </span>
                  )}
                  {type && (
                    <span className="uppercase text-[12px] tracking-[0.01em] ml-2 leading-none font-mammaBody">
                      ({type})
                    </span>
                  )}
                </React.Fragment>
              )}
              {product.attributes?.title}
              {!isArabic && (
                <React.Fragment>
                  {showCalories && product?.attributes?.kcal && (
                    <span className="uppercase text-[12px] ml-2 leading-none font-mammaBody">
                      {product?.attributes?.kcal} kcal
                    </span>
                  )}
                  {type && <span className="uppercase text-[12px] ml-2 leading-none font-mammaBody">({type})</span>}
                </React.Fragment>
              )}
            </p>
          )}
          <div className={` mb-auto ${isArabic ? 'text-left' : 'text-right'}`}>
            <p className="text-[12px] whitespace-pre-wrap tracking-[0.02em] leading-none font-mammaTitle">
              {product?.attributes.price}
            </p>
            {product?.attributes.price_mention && (
              <p className="uppercase text-[12px] tracking-[0.02em] leading-none font-mammaBody">
                {product?.attributes.price_mention}
              </p>
            )}
          </div>
          {isArabic && (
            <p translate="no" className="uppercase font-mammaTitle text-[12px] tracking-[0.02em] leading-[120%]">
              {isArabic && (
                <React.Fragment>
                  {showCalories && product?.attributes?.kcal && (
                    <span className="uppercase text-[12px] ml-2 tracking-[0.01em] leading-none font-mammaBody">
                      {product?.attributes?.kcal} kcal
                    </span>
                  )}
                  {type && (
                    <span className="uppercase text-[12px] tracking-[0.01em] ml-2 leading-none font-mammaBody">
                      ({type})
                    </span>
                  )}
                </React.Fragment>
              )}
              {product.attributes?.title}
              {!isArabic && (
                <React.Fragment>
                  {showCalories && product?.attributes?.kcal && (
                    <span className="uppercase text-[12px] ml-2 leading-none font-mammaBody">
                      {product?.attributes?.kcal} kcal
                    </span>
                  )}
                  {type && <span className="uppercase text-[12px] ml-2 leading-none font-mammaBody">({type})</span>}
                </React.Fragment>
              )}
            </p>
          )}
        </div>

        {productDescription && (
          <p
            className={`text-[14px] leading-[120%] mt-1 font-mammaBody whitespace-pre-wrap ${isArabic ? 'pl-14' : 'pr-14'}`}
          >
            {productDescription} {product?.attributes?.region && ` / ${product?.attributes?.region}`}
          </p>
        )}

        {showAllergens && product.attributes.allergens && (
          <div className={`flex gap-3 items-center mt-2.5 ${isArabic ? 'flex-row-reverse' : ''}`}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0_336_1945)">
                <path
                  d="M8 7.6665V10.9998"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 5.00643L8.00667 4.99902"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M7.99967 14.6668C11.6815 14.6668 14.6663 11.682 14.6663 8.00016C14.6663 4.31826 11.6815 1.3335 7.99967 1.3335C4.31777 1.3335 1.33301 4.31826 1.33301 8.00016C1.33301 11.682 4.31777 14.6668 7.99967 14.6668Z"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_336_1945">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <p className="text-[12px] leading-none mt-0.5">{product.attributes.allergens}</p>
          </div>
        )}
      </div>
    </div>
  )
}
